/**
 * Landing page: form submission and pricing button handlers.
 *
 * Enhances .signup-form elements (hero + footer) with fetch-based
 * submission to POST /api/newsletter/subscribe.
 */

const SUBSCRIBE_URL = "/api/newsletter/subscribe";
const PLAN_STORAGE_KEY = "ft_signup_plan";

function showMessage(
  form: HTMLFormElement,
  text: string,
  kind: "error" | "info" = "error",
) {
  let msg = form.querySelector<HTMLElement>(".signup-form__message");
  if (!msg) {
    msg = document.createElement("p");
    msg.className = "signup-form__message";
    form.appendChild(msg);
  }
  msg.textContent = text;
  msg.style.color = kind === "error" ? "#ef4444" : "#a3a3a3";
}

function scrollToSignup(): HTMLInputElement | null {
  const heroForm =
    document.querySelector<HTMLFormElement>(".hero .signup-form");
  if (!heroForm) return null;
  heroForm.scrollIntoView({ behavior: "smooth", block: "center" });
  const input = heroForm.querySelector<HTMLInputElement>('input[type="email"]');
  if (input) setTimeout(() => input.focus(), 400);
  return input;
}

// Pricing button: Free → scroll to signup form
document.getElementById("pricing-free-cta")?.addEventListener("click", () => {
  sessionStorage.removeItem(PLAN_STORAGE_KEY);
  scrollToSignup();
});

// Pricing button: Pro → scroll to signup form with pro intent
document.getElementById("pricing-pro-cta")?.addEventListener("click", () => {
  sessionStorage.setItem(PLAN_STORAGE_KEY, "pro");
  scrollToSignup();
});

function handleSubmit(form: HTMLFormElement) {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const input = form.querySelector<HTMLInputElement>('input[type="email"]');
    const button = form.querySelector<HTMLButtonElement>("button");
    if (!input || !button) return;

    const email = input.value.trim();
    if (!email) return;

    const plan = sessionStorage.getItem(PLAN_STORAGE_KEY);

    button.disabled = true;
    button.textContent = "Subscribing\u2026";

    try {
      const body: Record<string, string> = { email };
      if (plan) body.plan = plan;

      const res = await fetch(SUBSCRIBE_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await res.json<{ status?: string; error?: string }>();

      // Existing user — redirect to sign in regardless of HTTP status
      if (data.status === "exists") {
        window.location.href =
          "https://auth.formthirteen.com/login?redirect_uri=" +
          encodeURIComponent("https://formthirteen.com/subscriptions");
        return;
      }

      if (!res.ok) {
        button.textContent = "Subscribe Free";
        button.disabled = false;
        showMessage(form, data.error || "Something went wrong. Try again.");
        return;
      }

      // "created" or "verification_resent" — check inbox
      window.location.href = "/subscribed";
    } catch {
      button.textContent = "Subscribe Free";
      button.disabled = false;
      showMessage(form, "Network error. Try again.");
    }
  });
}

document
  .querySelectorAll<HTMLFormElement>(".signup-form")
  .forEach(handleSubmit);

export {};
